import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

const initialState = {
  courseGroups: [],
  courseGroupsLoading: false,
  courseGroupsError: null,
  requiredCourses: [],
  termSummary: [],
  studentRequiredCourse: {},
  errorMessage: undefined,
  dataFetchingStatus: false,
  coursesForGroup: [], // <-- add this
};

export const courseGroupsRequest = (data) => (dispatch) => {
  
  dispatch(setErrorMessage(undefined));
  dispatch(setDataFetchingStatus(true));
  
  // Add authorization header
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
    
  axios
    .get("/studentdashboard", data)

    .then((response) => {
      console.log("studentdashboard",response)
      dispatch(setDataFetchingStatus(false));
      dispatch(setCourseGroups(response.data));
      
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      console.error("Course Groups API Error:", error);
      if (error.response && error.response.data) {
        dispatch(setErrorMessage(error.response.data));
      } else {
        dispatch(setErrorMessage({ error: "Failed to fetch course groups data" }));
      }
    });
};

export const getCourseGroups = (data) => (dispatch) => {
  console.log("data",data)
  const degreeId ="b81cc6b1-7d81-ef11-ac21-00224808176b";

  const studentId = localStorage.getItem("studentId");
  dispatch(setErrorMessage(undefined));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post("/students/degreecourses", { degreeId, studentId })
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      if (response.status === 404) {
        dispatch(setErrorMessage(response.data.error));
      } else {
        // Set only the groupCourses array in Redux state
        dispatch(setCourseGroups(response.data.groupCourses));
      }
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response?.data?.error || "Failed to fetch course groups"));
    });
};

// Thunk to fetch courses for a selected group
export const getCoursesForGroup = (groupId) => (dispatch, getState) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));

  // Find the group in the already loaded courseGroups
  const { courseGroups } = getState().dashboard;
  const group = courseGroups.find(
    (g) => g.ses_advanceddegreeplancoursegroupid === groupId
  );

  if (group && group.data) {
    dispatch(setCoursesForGroup(group.data));
    dispatch(setDataFetchingStatus(false));
    return Promise.resolve();
  } else {
    // If you want to fetch from API, replace this with an API call
    dispatch(setCoursesForGroup([]));
    dispatch(setDataFetchingStatus(false));
    return Promise.resolve();
  }
};

export const dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState,
  reducers: {
    setCourseGroups: (state, action) => {
      state.courseGroups = action.payload;
    },
    setCourseGroupsLoading: (state, action) => {
      state.courseGroupsLoading = action.payload;
    },
    setCourseGroupsError: (state, action) => {
      state.courseGroupsError = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
    setRequiredCourses: (state, action) => {
      state.requiredCourses = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setTermSummary: (state, action) => {
      state.termSummary = action.payload;
    },
    setStudentRequiredCourse: (state, action) => {
      state.studentRequiredCourse = action.payload;
    },
    setCoursesForGroup: (state, action) => {
      state.coursesForGroup = action.payload;
    },
    clearDashboardData: (state) => {
      state.courseGroups = [];
      state.courseGroupsLoading = false;
      state.courseGroupsError = null;
      state.requiredCourses = [];
      state.termSummary = [];
      state.studentRequiredCourse = {};
      state.coursesForGroup = [];
    },
  },
});

export const {
  setCourseGroups,
  setCourseGroupsLoading,
  setCourseGroupsError,
  setDataFetchingStatus,
  setRequiredCourses,
  setErrorMessage,
  setTermSummary,
  setStudentRequiredCourse,
  setCoursesForGroup,
  clearDashboardData,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
